// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2ZO1w","requiredAsterisk":"Info_requiredAsterisk__2qM97"};